import { AxiosInstance } from 'axios';
import { TApiResponse } from '@type/common';
import {
  ICreateCustomersParams,
  IUpdateCustomersParams,
} from '@type/customer/customerList';
import {
  UpdateCustomerPaidStatusPayload,
  UpdateCustomerPaidStatusResponse,
  IGetLineBindingStatusParams,
  IGetLineBindingStatusResponse,
  IGetStaffsListParams,
  IGetStaffsListStatusResponse,
  IGetCustomersListParams,
  IGetCustomersListStatusResponse,
  IGetDepartmentStaffsListStatusResponse,
  IGetDepartmentStaffsListParams,
  ICreateStudentParams,
  ICreateStudentResponse,
  IUpdateStudentParams,
  IUpdateCustomer,
  IGetStudentResponse,
} from './member.type';

export default (axios: AxiosInstance, apiPrefix: string) => ({
  /* 更新會員繳款狀態、控制啟用停用 */
  updateCustomerPaidStatus(
    oneClubId: string,
    payload: UpdateCustomerPaidStatusPayload,
  ): TApiResponse<UpdateCustomerPaidStatusResponse> {
    return axios.patch(
      `${apiPrefix}/backend/member/customer/${oneClubId}`,
      payload,
    );
  },

  // 取得line綁定狀態
  getLineBindingStatus(
    params: IGetLineBindingStatusParams,
  ): TApiResponse<IGetLineBindingStatusResponse> {
    return axios.get(
      `${apiPrefix}/backend/member/${params.oneClubId}/line-binding`,
    );
  },

  // 取得員工列表
  getStaffList(
    params: IGetStaffsListParams,
  ): TApiResponse<IGetStaffsListStatusResponse> {
    return axios.get(`${apiPrefix}/backend/member/staffs/list`, { params });
  },

  getCustomerList(
    params: IGetCustomersListParams,
  ): TApiResponse<IGetCustomersListStatusResponse> {
    return axios.get(`${apiPrefix}/backend/member/customers/list`, { params });
  },
  createCustomer(data: ICreateCustomersParams): TApiResponse<{
    id: string;
    name: string;
    parentOneClubId: string;
  }> {
    return axios.post(`${apiPrefix}/backend/member/create-customer`, data);
  },
  updateCustomer(
    oneClubId: string,
    data: IUpdateCustomersParams,
  ): TApiResponse<IUpdateCustomer> {
    return axios.patch(
      `${apiPrefix}/backend/member/customer/${oneClubId}`,
      data,
    );
  },

  // 取得成員資料
  getStudent(studentId: string): TApiResponse<IGetStudentResponse> {
    return axios.get(`${apiPrefix}/backend/member/student/${studentId}`);
  },

  // 建立會員下的「成員」
  createStudent(
    params: ICreateStudentParams,
  ): TApiResponse<ICreateStudentResponse> {
    return axios.post(`${apiPrefix}/backend/member/create-student`, params);
  },

  // 更新成員資料
  updateStudent(
    studentId: string,
    params: IUpdateStudentParams,
  ): TApiResponse<any> {
    return axios.patch(
      `${apiPrefix}/backend/member/student/${studentId}`,
      params,
    );
  },

  // 取得部門員工列表
  getDepartmentStaffList(
    params: IGetDepartmentStaffsListParams,
  ): TApiResponse<IGetDepartmentStaffsListStatusResponse> {
    return axios.get(`${apiPrefix}/backend/member/staffs/getByDepartment`, {
      params,
    });
  },
});
